import {createApp} from 'vue';
import App from './views/App.vue';
import dayjs from 'dayjs';
import axios from 'axios';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import ja from 'dayjs/locale/ja';
import router from './routers/router.js';
import i18n from './plugins/i18n.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

createApp(App)
    .use(router)
    .use(i18n)
    .mount('#app');

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');
dayjs.locale(ja);